import React from 'react'

export function MenuInner() {

  return (
    <div className='d-flex align-items-center'>
      <div className='fs-2hx text-gray800'>Müşteriler</div>
    </div>
  )
}
